import { render, staticRenderFns } from "./gears.vue?vue&type=template&id=1d0b7ffa&scoped=true&"
import script from "./gears.vue?vue&type=script&lang=js&"
export * from "./gears.vue?vue&type=script&lang=js&"
import style0 from "./gears.vue?vue&type=style&index=0&id=1d0b7ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0b7ffa",
  null
  
)

export default component.exports